/*
 * Copyright (c) 2022. Nedaware SL
 */

import {FilterInterface, InvalidFilterProperty, InvalidFilterValue} from "../../api/filter-interface";
import {InternalPropertyMap} from "../basic-entity-interface/mapping-internal";

/**
 * Nedaware S.L.
 * @author David Campos Rodríguez <david.campos.r96@gmail.com>
 */

/**
 * Filter to connect with the exists filter in the backend.
 * Accepts anything evaluating it to true or false. Several values
 * are not accepted.
 */
export class ExistsFilter implements FilterInterface {
    dataToParams(property: InternalPropertyMap, data: any[] | any): { [p: string]: string | string[] } {
        if (property == null) {
            throw new InvalidFilterProperty(property, "the property cannot be null");
        }
        if (Array.isArray(data)) {
            throw new InvalidFilterValue(data, "only a single value is accepted");
        }
        return {[`${property.paramName}[exists]`]: (data ? 'true' : 'false')};
    }
}
